import { render, staticRenderFns } from "./AtmosphericPrecipitation.vue?vue&type=template&id=4c0563b8&"
import script from "./AtmosphericPrecipitation.vue?vue&type=script&lang=js&"
export * from "./AtmosphericPrecipitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports